import { render, staticRenderFns } from "./NavButtonItem.vue?vue&type=template&id=6e510906&scoped=true&"
import script from "./NavButtonItem.vue?vue&type=script&lang=ts&"
export * from "./NavButtonItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavButtonItem.vue?vue&type=style&index=0&id=6e510906&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e510906",
  null
  
)

export default component.exports